import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useSearchParams, useNavigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Feed from './pages/Feed';
import Thread from './pages/Thread';
import Profile from './pages/Profile';
import AuthModal from './components/AuthModal';
import Toast from './components/Toast';

// Component to handle OAuth callback
function OAuthHandler({ showToast }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (token) {
      localStorage.setItem('token', token);
      showToast('Signed in successfully!');
      navigate('/', { replace: true });
      window.location.reload(); // Reload to update auth state
    } else if (error) {
      showToast('Authentication failed. Please try again.');
      navigate('/', { replace: true });
    }
  }, [searchParams, navigate, showToast]);

  return null;
}

function App() {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState('signin');
  const [toast, setToast] = useState({ show: false, message: '' });
  const [searchQuery, setSearchQuery] = useState('');

  const openAuthModal = (mode = 'signin') => {
    setAuthMode(mode);
    setAuthModalOpen(true);
  };

  const closeAuthModal = () => {
    setAuthModalOpen(false);
  };

  const showToast = (message) => {
    setToast({ show: true, message });
    setTimeout(() => setToast({ show: false, message: '' }), 3000);
  };

  return (
    <AuthProvider>
      <Router>
        <OAuthHandler showToast={showToast} />
        <Navbar openAuthModal={openAuthModal} showToast={showToast} searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        <Routes>
          <Route path="/" element={<Feed openAuthModal={openAuthModal} showToast={showToast} searchQuery={searchQuery} />} />
          <Route path="/thread/:id" element={<Thread openAuthModal={openAuthModal} showToast={showToast} />} />
          <Route path="/profile/:username" element={<Profile />} />
        </Routes>
        <AuthModal 
          isOpen={authModalOpen} 
          onClose={closeAuthModal} 
          mode={authMode}
          setMode={setAuthMode}
          showToast={showToast}
        />
        <Toast show={toast.show} message={toast.message} />
      </Router>
    </AuthProvider>
  );
}

export default App;

